import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'ddc-track-event';
import { useRequestData } from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';
import { publishVehicleData } from '../../../utilities/vehicleTracking';
import { simplifiedListingsFlagKey } from '../../../global-constants';

const VehicleLink = ({ link, uuid, children }) => {
	const { windowId, widgetName } = useRequestData();
	return link ? (
		<a
			href={link}
			onClick={() => {
				if (isBrowser) {
					window?.DDC?.sendOptimizelyEvent(
						'user_conversion',
						simplifiedListingsFlagKey
					);
				}
				trackEvent(widgetName, windowId, {
					element: 'Vehicle photo',
					result: 'Navigated to VDP'
				});
				publishVehicleData(uuid);
			}}
		>
			{children}
		</a>
	) : (
		children
	);
};

export default VehicleLink;

VehicleLink.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
		.isRequired,
	link: PropTypes.string,
	uuid: PropTypes.string.isRequired
};

VehicleLink.defaultProps = {
	link: ''
};
